import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { CalendarClock, Ticket } from "lucide-react";
import { api } from "@/lib/api";
import { timeUntil } from "@/lib/format";

// Events (across the user's bloqs) they hold a ticket to and that start soon. Sourced from the
// aggregated GET /me/upcoming-events endpoint (replaces the old per-bloq useQueries fan-out).
// Shown at the top of the BLOQs list as an in-app reminder.
export function UpcomingEventsStrip() {
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: ["me-upcoming-events"],
    queryFn: api.upcomingEvents,
    retry: false,
    staleTime: 60000,
  });

  const now = Date.now();
  const events = (data?.events || []).filter(
    (ev) => ev.my_ticket && ev.status === "scheduled" && new Date(ev.starts_at).getTime() > now,
  );
  if (events.length === 0) return null;
  events.sort((a, b) => new Date(a.starts_at) - new Date(b.starts_at));
  const top = events.slice(0, 3);

  return (
    <div data-testid="upcoming-events-strip">
      <div className="flex items-center gap-1.5 px-2 pb-1 pt-2 text-[11px] font-bold uppercase tracking-wider text-bloq-purple">
        <CalendarClock className="h-3 w-3" /> Your upcoming events
      </div>
      <div className="space-y-1.5">
        {top.map((ev) => (
          <button
            key={ev.id}
            onClick={() => navigate(`/app/bloqs/${ev.circle_id}?info=1`)}
            className="flex w-full items-center gap-3 rounded-2xl border border-bloq-purple/25 bg-bloq-purple/[0.06] p-3 text-left transition-colors hover:bg-bloq-purple/10"
            data-testid={`upcoming-event-${ev.id}`}
          >
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-bloq-purple/20 text-bloq-purple"><Ticket className="h-4 w-4" /></span>
            <div className="min-w-0 flex-1">
              <div className="truncate text-sm font-semibold text-white">{ev.title}</div>
              <div className="truncate text-[11px] text-bloq-muted">{ev.circle_name}</div>
            </div>
            <span className="shrink-0 rounded-full bg-bloq-purple/15 px-2 py-0.5 text-[11px] font-bold text-bloq-purple" data-testid={`upcoming-event-when-${ev.id}`}>
              {timeUntil(ev.starts_at)}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
